import { GenericAPIError } from './generic-error';

export class StatusCodeError extends GenericAPIError {
  statusCode: number;
  response: Response;

  constructor(resp: Response) {
    super('Status code 400 or higher');
    this.name = 'StatusCodeError';

    this.response = resp;
    this.statusCode = resp.status;
  }

  getErrorStatusMessage() {
    return new Promise<string>((resolve, reject) => {
      this.response
        .text()
        .then(text => {
          const { status } = JSON.parse(text);

          resolve(status);
        })
        .catch(() => {
          reject('');
        });
    });
  }
}
